import React from "react";
import { connect } from "react-redux";
import { Row, Modal, Col } from "react-bootstrap";
import { userActions, utilActions } from "../../_actions";
import { userService } from "../../_services";
import { Formik, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { celularSchema, CELULAR_AYUDA, LoadingBoton, ErrorMessage, TIPO_IMAGEN } from "../../_helpers";
import Select from "react-select";
import _ from "lodash";
import authService from "../../_services/cart/authService";
import vendedorService from "../../_services/cart/vendedor.service";
import alertService from "../../_services/cart/alert.service";
import { InputMask } from '@react-input/mask';
import MiUploadArchivo from "../../_helpers/MiUploadArchivo";

/*
 * Donde quedo cada campo ahora que el formulario esta repartido en solapas.
 *
 * Los <Tabs> muestran una sola por vez, asi que un campo invalido en otra solapa deja el
 * submit trabado con el mensaje de error fuera de pantalla: se apretaba "Grabar cambios"
 * y no pasaba absolutamente nada. Con esto el aviso puede decir que falta y donde.
 */
const SOLAPA_DE_CAMPO = {
  firstName: "Mis datos",
  lastName: "Mis datos",
  numeroCelular: "Mis datos",
  email: "Mis datos",
  username: "Mis datos",
  descripcionPerfil: "Mis datos",
  plantillaDescripcion: "Mis datos",
  linkFacebook: "Mis datos",
  linkInstagram: "Mis datos",
  linkWeb: "Mis datos",
  alias: "Cobros",
  cbu: "Cobros",
  direccion: "Ubicación",
  codigoPostal: "Ubicación",
  ciudad: "Ubicación",
  provincia: "Ubicación",
  latitud: "Ubicación",
  longitud: "Ubicación",
};

/** El rotulo que la persona ve en pantalla, para nombrarlo igual en el aviso. */
const ETIQUETA_DE_CAMPO = {
  firstName: "Nombre",
  lastName: "Apellido",
  numeroCelular: "Teléfono Celular",
  email: "Mail",
  username: "Usuario",
  descripcionPerfil: "Descripción",
  plantillaDescripcion: "Texto al pie de mis publicaciones",
  linkFacebook: "Pagina Facebook",
  linkInstagram: "Pagina Instagram",
  linkWeb: "Pagina Web",
  alias: "Alias",
  cbu: "CBU",
  direccion: "Dirección",
  codigoPostal: "Codigo Postal",
  ciudad: "Ciudad",
  provincia: "Provincia",
  latitud: "Latitud",
  longitud: "Longitud",
};

class FormDatosUsuario extends React.Component {
  constructor(props) {
    super(props);
//    this.usuarioExiste = _.debounce(this.usuarioExiste, 300);
  //  this.mailExiste = _.debounce(this.mailExiste, 300);
  }

  state = {
    provincias: [],
    grabando: false,
    mostrar: false,
  };

  componentDidMount() {
    vendedorService.getProvincias(this.setProvincias);
  }

  setProvincias = (provincias) => {
    this.setState({ provincias: provincias });
  };

  /*usuarioExiste = (value) => {
    return userService.chequearUsuarioExiste(value).then(
      (data) => {
        if (data.status === 1) return false;
        if (data.status === 3) return true;
        return false;
      },
      (error) => {
        return true;
      }
    );
  };

  mailExiste = (value) => {
    return userService.chequearMailExiste(value).then(
      (data) => {
        if (data.status === 1) return false;
        if (data.status === 3) return true;
        return false;
      },
      (error) => {
        return true;
      }
    );
  };*/

  setGrabando = (grab) => {
    this.setState({ grabando: grab });
  };

  /*
   * Enter para grabar. Los campos ya no viven adentro de un <form> (ver `botonGrabar`),
   * asi que el submit implicito del navegador no existe y hay que replicarlo.
   *
   * Si el Enter sale de un <form>, es de otra solapa —la de Seguridad tiene el suyo— y
   * se maneja sola: sin este corte, apretar Enter para cambiar la clave grababa el perfil.
   */
  enterGraba = (event) => {
    if (event.key !== "Enter") return;
    if (event.target.tagName === "TEXTAREA") return;
    if (event.target.closest && event.target.closest("form")) return;

    if (this.submitForm) this.submitForm();
  };

  /*
   * Grabar, avisando si lo que traba el submit quedo en otra solapa.
   *
   * Formik por si solo no manda nada cuando hay un campo invalido, y el mensaje se dibuja
   * al lado del campo: si ese campo esta en una solapa que no se ve, el boton parecia no
   * responder. Asi que primero se valida a mano, y si algo falla se nombra el campo y su
   * solapa, y se marcan como tocados para que los mensajes ya esten ahi al ir a mirar.
   */
  grabar = async (validateForm, setTouched, handleSubmit) => {
    const errores = await validateForm();
    const campos = Object.keys(errores);

    if (campos.length === 0) {
      handleSubmit();
      return;
    }

    setTouched(
      campos.reduce((acc, campo) => ({ ...acc, [campo]: true }), {}),
      false
    );

    const campo = campos[0];
    const etiqueta = ETIQUETA_DE_CAMPO[campo] || campo;
    const solapa = SOLAPA_DE_CAMPO[campo];

    alertService.error(
      solapa
        ? `Revisá "${etiqueta}", en la solapa ${solapa}: ${errores[campo]}`
        : `Revisá "${etiqueta}": ${errores[campo]}`
    );
  };

  render() {

    let esVendedor = this.props.esVendedor;

    let inic = {
      latitud: "",
      longitud: "",
      direccion: "",
      codigoPostal: "",
      ciudad: "",
      imagenes: [],
      provincia: {},
      firstName: "",
      lastName: "",
      email: "",
      numeroCelular: "",
      username: "",
      password: "",
      confpassword: "",
      alias:'',
      cbu:'',
      plantillaDescripcion: ''
    };

    let user = _.clone(authService.getLoggedUserDetail());

    const passwoordRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;

    let validationSchema = Yup.object().shape({
      firstName: Yup.string()
        .min(2, "Muy corto")
        .max(100, "No puede exceder los 100 caracteres")
        .required("Requerido"),
      lastName: Yup.string()
        .min(2, "Muy corto")
        .max(100, "No puede exceder los 100 caracteres")
        .required("Requerido"),
      linkWeb: Yup.string()
        .max(100, "No puede exceder los 100 caracteres"),
      linkFacebook: Yup.string()
        .max(100, "No puede exceder los 100 caracteres"),
      linkInstagram: Yup.string()
        .max(100, "No puede exceder los 100 caracteres"),
      descripcionPerfil: Yup.string()
        .max(8000, "No puede exceder los 8000 caracteres"),
      plantillaDescripcion: Yup.string()
        .max(4000, "No puede exceder los 4000 caracteres"),


      // Obligatorio, igual que en el registro: si desde acá se pudiera dejar en blanco, la regla
      // valdria solo hasta la primera vez que alguien edita su perfil.
      numeroCelular: celularSchema,
      username: Yup.string()
        .min(2, "Muy corto")
        .max(50, "No puede exceder los 50 caracteres")
        .test("checkDuplUsername", "Usuario  existente", (value) => {
          return new Promise((res, rej) => {
            if (user && value === inic.username) return res(true);
            else {
              return res(true);
            }
          });
        })
        .required("Requerido"),
      email: Yup.string()
        .min(2, "Muy corto")
        .max(100, "No puede exceder los 100 caracteres")
        .test("checkDuplEmail", "Mail existente", (value) => {
          return new Promise((res, rej) => {
            if (user && value === inic.email) return res(true);
            else {
              return res(true);
            }
          });
        })
        .required("Requerido"),
    });
    const customSelect = {
      control: (provided) => ({
        // class attribute : class=" css-i32vvf-control"
        ...provided,
        background: "transparent",
        display: "flex",
        flexWrap: "nowrap",
        borderColor: "hsl(0deg 0% 80%);",
        width: "100%",
        height: "48px",
      }),
    };
    if (user !== undefined && user !== {})
      inic = utilActions.setearValores(inic, user);
    return (
      <div onKeyDown={this.enterGraba}>
        <Formik
          enableReinitialize={true}
          initialValues={inic}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            this.setGrabando(true);
            values.cambioUsuario = values.username != user.username;
            values.cambioMail = values.email != user.email;

            userService.editarUsuario(values).then(
              (data) => {
                alertService.msg(
                  "Se han actualizado los valores correctamente"
                );
                this.setGrabando(false);
                this.props.getLogueado();
              },
              (error) => {
                this.props.enviarError(error);
                this.setGrabando(false);
              }
            );
          }}
        >
          {({
            errors,
            touched,
            values,
            handleSubmit,
            setFieldValue,
            validateForm,
            setTouched,
          }) => {
            /*
             * El form no se dibuja de una: expone sus secciones y el padre las reparte
             * entre las solapas del perfil (datos / cobros / ubicacion).
             *
             * El <Formik> sigue siendo uno solo y envuelve a los <Tabs>, asi que "Grabar
             * cambios" guarda el perfil entero desde cualquier solapa. Con un form por
             * solapa no alcanzaba: `editarUsuario` manda el usuario completo, y la solapa
             * que quedaba montada con los valores viejos revertia lo que se habia guardado
             * en la otra.
             */
            this.submitForm = () =>
              this.grabar(validateForm, setTouched, handleSubmit);

            const secciones = {};

            secciones.datosUsuario = (
              <>
              <h4>Datos de usuario</h4>
              <div className="dashboard__content-prod">
                <div className="form-group">
                  <label htmlFor="firstName">Nombre</label>
                  <Field className="form-control" name="firstName" />
                  <ErrorMessage name={`firstName`} />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Apellido</label>
                  <Field className="form-control" name="lastName" />
                  <ErrorMessage name={`lastName`} />
                </div>
                <div className="form-group">
                  <label htmlFor="telefono">Teléfono Celular</label>
                  {/* <InputMask mask="+54 (___) ____-____" replacement={{ _: /\d/ }} onMask={(event) => {
                      const { value, input, parts, pattern, isValid } = event.detail;
                      console.log(value, input, parts, pattern, isValid)
                      setFieldValue('numeroCelular', value)
                    }}/> */}
                   <Field className="form-control" name="numeroCelular" type="tel" inputMode="tel" />
                  <ErrorMessage name={`numeroCelular`} />
                  <small className="form-hint">{CELULAR_AYUDA}</small>
                </div>
                <div className="form-group">
                  <label htmlFor="email">Mail </label>
                  <Field className="form-control" name="email" />
                  <ErrorMessage name={`email`} />
                </div>
                <div className="form-group">
                  <label htmlFor="username">Usuario </label>
                  <Field className="form-control" name="username" />
                  <ErrorMessage name={`username`} />
                </div>
              </div>
              </>
            );

            // Alias y CBU son del vendedor: el comprador no cobra nada.
            secciones.pago = !esVendedor ? null : (
             <>
              <h4>Datos de pago</h4>
              <div className="dashboard__content-prod">
                  <div className="form-group">
                    <label htmlFor="alias">Alias </label>
                    <Field className="form-control" name="alias" />
                    <ErrorMessage name={`alias`} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="cbu">CBU </label>
                    <Field className="form-control" name="cbu" />
                    <ErrorMessage name={`cbu`} />
                  </div>
              </div>
              </>
            );

            secciones.ubicacion = (
              <>
              <h4>Datos de ubicación</h4>
              <div className="dashboard__content-prod">
                <div className="form-group">
                  <label htmlFor="direccion">Dirección </label>
                  <Field className="form-control" name="direccion" />
                  <ErrorMessage name={`direccion`} />
                </div>
                <div className="form-group">
                  <label htmlFor="codigoPostal">Codigo Postal </label>
                  <Field className="form-control" name="codigoPostal" />
                  <ErrorMessage name={`codigoPostal`} />
                </div>
                <div className="form-group">
                  <label htmlFor="ciudad">Ciudad </label>
                  <Field className="form-control" name="ciudad" />
                  <ErrorMessage name={`ciudad`} />
                </div>
                <div className="form-group">
                  <label htmlFor="provincia">Provincia </label>
                  <Select
                    styles={customSelect}
                    value={
                      this.state.provincias
                        ? this.state.provincias.find(
                            (option) => option.id == values.provincia?.id
                          )
                        : ""
                    }
                    getOptionLabel={(option) => `${option.nombre}`}
                    getOptionValue={(option) => option.id}
                    onChange={(so) => {
                      setFieldValue(`provincia`, so);
                    }}
                    isSearchable={false}
                    placeholder="Seleccione una"
                    options={this.state.provincias}
                  />
                  <ErrorMessage name={`provincia`} />
                </div>



              {esVendedor &&
                <>
                <div className="form-group">
                    <label htmlFor="latitud">Latitud </label>
                    <Field className="form-control" name="latitud" />
                    <ErrorMessage name={`latitud`} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="longitud">Longitud </label>
                    <Field className="form-control" name="longitud" />
                    <ErrorMessage name={`longitud`} />
                  </div>


                </>}
              </div>
              </>
            );

            secciones.perfil = (
              <>
              <h4>Datos de perfil</h4>
              <div className="dashboard__content-prod">
                <div className="form-group--textarea">
                  <div className="textarea-container">
                      <label htmlFor="descripcionPerfil">Descripción</label>
                      <Field
                          as="textarea"
                          name="descripcionPerfil"
                          rows="4"
                          cols="10"
                          className="input--outline"
                      />
                      <ErrorMessage name={`descripcionPerfil`}/>
                  </div>
                </div>
                {esVendedor && (
                <div className="form-group--textarea">
                  <div className="textarea-container">
                      <label htmlFor="plantillaDescripcion">Texto al pie de mis publicaciones</label>
                      <small className="form-text text-muted">
                        Se agrega al final de la descripción de todas tus publicaciones (quiénes son, horarios, envíos, facturación...).
                      </small>
                      <Field
                          as="textarea"
                          name="plantillaDescripcion"
                          rows="8"
                          cols="10"
                          className="input--outline"
                      />
                      <ErrorMessage name={`plantillaDescripcion`}/>
                  </div>
                </div>
                )}
            </div>
              </>
            );

            secciones.redes = (
              <>
            <h4>Redes sociales</h4>
            <div className="dashboard__content-prod">
            <div className="form-group">
                    <label htmlFor="linkFacebook">Pagina Facebook </label>
                    <Field className="form-control" name="linkFacebook" />
                    <ErrorMessage name={`linkFacebook`} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="linkInstagram">Pagina Instagram </label>
                    <Field className="form-control" name="linkInstagram" />
                    <ErrorMessage name={`linkInstagram`} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="linkWeb">Pagina Web </label>
                    <Field className="form-control" name="linkWeb" />
                    <ErrorMessage name={`linkWeb`} />
                  </div>
            </div>
              </>
            );

            secciones.imagenes = (
              <>
            <h4>Subir imagenes</h4>
            <div className="dashboard__content-prod">
                <div  >
                    <FieldArray
                        name="imagenes"
                        render={(arrayHelpers) => (
                            <>
                                {/*
                                    El banner se muestra siempre, sea o no vendedor: es la marca
                                    del usuario, no algo ligado a una baja puntual. Despues se
                                    agrega solo como ultima imagen de cada publicacion suya.
                                */}
                                <div className="even-columns">
                                    <div>
                                        <label htmlFor="fotoBanner">Banner de publicaciones (marca)</label>
                                        <MiUploadArchivo
                                            type = 'IMAGEN'
                                            idUnique="fotoBannerPublicaciones"
                                            tipo={TIPO_IMAGEN.BANNER_PUBLICACIONES}
                                            setFieldValue={setFieldValue}
                                            values={values}
                                            arrayHelpers={arrayHelpers}
                                        ></MiUploadArchivo>
                                        <small className="form-hint">
                                            Se agrega como ultima imagen en la galeria de cada una de tus publicaciones, para que se vea tu marca.
                                        </small>
                                    </div>
                                </div>

                                {/* Para repuestos tradicionales, permitir una sola foto por ahora */}
                                {!values.esBaja && (
                                    <div className="even-columns">
                                        <div>
                                        <label htmlFor="foto1">Foto 1</label>
                                            <MiUploadArchivo
                                                type = 'IMAGEN'
                                                idUnique="fotoGeneral1"
                                                tipo={TIPO_IMAGEN.FRENTE}
                                                setFieldValue={setFieldValue}
                                                values={values}
                                                arrayHelpers={arrayHelpers}
                                            ></MiUploadArchivo>
                                        </div>

                                        <div>
                                            <label htmlFor="foto1">Foto 2</label>
                                            <MiUploadArchivo
                                                type = 'IMAGEN'
                                                idUnique="fotoGeneral2"
                                                tipo={TIPO_IMAGEN.ATRAS}
                                                setFieldValue={setFieldValue}
                                                values={values}
                                                arrayHelpers={arrayHelpers}
                                            ></MiUploadArchivo>
                                        </div>

                                        <div>
                                            <label htmlFor="foto1">Foto 3</label>
                                            <MiUploadArchivo
                                                type = 'IMAGEN'
                                                idUnique="fotoGeneral3"
                                                tipo={TIPO_IMAGEN.CONDUCTOR}
                                                setFieldValue={setFieldValue}
                                                values={values}
                                                arrayHelpers={arrayHelpers}
                                            ></MiUploadArchivo>
                                        </div>

                                        <div>
                                            <label htmlFor="foto1">Foto 4</label>
                                            <MiUploadArchivo
                                                type = 'IMAGEN'
                                                idUnique="fotoGeneral4"
                                                tipo={TIPO_IMAGEN.ACOMPANIANTE}
                                                setFieldValue={setFieldValue}
                                                values={values}
                                                arrayHelpers={arrayHelpers}
                                            ></MiUploadArchivo>
                                        </div>
                                    </div>
                                )}

                            </>
                        )}
                    />
                </div>
            </div>
              </>
            );

            /*
             * `type="button"` y submit llamado a mano porque no hay <form> alrededor: la
             * solapa de Seguridad trae su propio <Formik> con su <form>, y anidar forms es
             * HTML invalido —el navegador cierra el de afuera y el boton de cambiar la
             * clave deja de andar—. El Enter lo cubre `enterGraba`.
             */
            const botonGrabar = (
              <div className="login__socialButtons">
                <div className="footer__buttons">
                  <button
                    className="button"
                    type="button"
                    data-type="primary"
                    disabled={this.state.grabando}
                    onClick={() =>
                      this.grabar(validateForm, setTouched, handleSubmit)
                    }
                  >
                    Grabar cambios
                    <LoadingBoton grabando={this.state.grabando} />
                  </button>
                </div>
              </div>
            );

            return this.props.children({ secciones, botonGrabar });
          }}
        </Formik>
      </div>
    );
  }
}

function mapState(state) {
  return {};
}

const actionCreators = {
  login: userActions.login,
  getLogueado: userActions.getLogueado,
};

const connectedFormDatosUsuario = connect(
  mapState,
  actionCreators
)(FormDatosUsuario);
export { connectedFormDatosUsuario as FormDatosUsuario };
